<template>
	<div class="videolist">
		<div class="breadcrumb">兑换码列表</div>
		<div class="searchBtn" style="border:none;display:flex">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加兑换码</el-button>
			<el-date-picker
		      	v-model="timeVal"
	      		type="daterange"
	      		range-separator=" 至 "
	      		start-placeholder="创建开始日期"
	      		end-placeholder="创建结束日期"
      			value-format="yyyy-MM-dd" style="margin:0 10px">
		    </el-date-picker>
		    <el-button type="primary" @click="search_mine">搜索</el-button>
	    </div>
	    <el-table ref="multipleTable" :data="tableData3" highlight-current-row  tooltip-effect="dark" style="width: 100%">
		    <el-table-column prop="id" label="ID"></el-table-column>
		    <el-table-column prop="title" label="兑换码名称"></el-table-column>
		    <el-table-column prop="type" label="兑换码类型"></el-table-column>
		    <el-table-column prop="vipType" label="会员类型">
		    	<template slot-scope="scope">
		    		{{scope.row.vipType==1?'VIP':
        				scope.row.vipType==2?'LIVE_VIP':
        				scope.row.vipType==3?'AI_VIP':'VIP+AI_VIP'
        			}}
		    	</template>
		    </el-table-column>
		    <el-table-column prop="type" label="销售类型">
		    	<template slot-scope="scope">
		    		{{scope.row.salesTypeCode+'-'+scope.row.salesType}}
		    	</template>
		    </el-table-column>
		    <el-table-column prop="type" label="有效期">
		    	<template slot-scope="scope">
		    		{{scope.row.durationType==1?scope.row.duration+'天':scope.row.duration+'个月'}}
		    	</template>
		    </el-table-column>

		    <el-table-column prop="quantity" label="生成总数"></el-table-column>
		    <el-table-column prop="remaining" label="剩余总数"></el-table-column>
		    <!-- <el-table-column prop="validStartTime" :formatter="this.global.dateFormat" label="生效日期" width="190"></el-table-column>
		    <el-table-column prop="validEndTime" :formatter="this.global.dateFormat" label="截至日期" width="190"></el-table-column> -->
		    <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建日期" ></el-table-column>
			<el-table-column prop="id" label="兑换详情" align='center'>
				<template slot-scope="scope">
					<i class="el-icon-more-outline" @click="convertDetail(scope.row.id)" style="cursor:pointer"></i>
				</template>
			</el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>

		<!-- 添加兑换码弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="120px">
      			<el-form-item label="兑换码名称" prop="title">
				    <el-input v-model="ruleForm.title" style="width: 80%;"></el-input>
				</el-form-item>
				<el-form-item label="兑换码类型" prop="typeId">
				    <el-select v-model="ruleForm.typeId" placeholder="请选择兑换码类型" @change="typeId" style="width: 80%;">
				     	<el-option
					      	v-for="item in exchangeCodeTypeData"
					      	:key="item.id"
					      	:label="item.type"
					      	:value="item.id">
					    </el-option>
				    </el-select>
				</el-form-item>

				<el-form-item label="会员类型" prop="vipType">
				    <el-select v-model="ruleForm.vipType" placeholder="请选择会员类型" style="width: 80%;">
				     	<el-option
					      	v-for="item in vipTypeList"
					      	:key="item.id"
					      	:label="item.type"
					      	:value="item.id">
					    </el-option>
				    </el-select>
				</el-form-item>

				<input type="hidden" v-model="ruleForm.salesTypeId" >
				<el-form-item label="销售类型" prop="salesTypeId" v-if="typeIdShow">
				    <el-select v-model="ruleForm.salesName" placeholder="请选择销售类型" @change="salesTypeId" style="width: 80%;">
				     	<el-option
					      	v-for="item in salesTypeData"
					      	:key="item.id"
					      	:label="item.salesTypeCode+'-'+item.salesType"
					      	:value="item.id">
					    </el-option>
				    </el-select>
				</el-form-item>
				<input type="hidden" v-model="ruleForm.durationId" >
				<el-form-item label="有效期" prop="durationId" v-if="salesTypeIdShow">
				    <el-select v-model="ruleForm.durationName" placeholder="请选择有效期" @change="durationId" style="width: 80%;">
				     	<el-option
					      	v-for="item in durationData"
					      	:key="item.id"
					      	:label="item.durationType==1?item.duration+'天':item.duration+'个月'"
					      	:value="item.id">
					    </el-option>
				    </el-select>
				</el-form-item>
				
			  	<el-form-item label="生成数量(张)" prop="quantity">
				    <el-input v-model.number="ruleForm.quantity" placeholder="仅支持数字" style="width: 80%;"></el-input>
				</el-form-item>
		        <el-form-item label="生效日期" prop="validStartTime">
				    <el-date-picker
				      	v-model="ruleForm.validStartTime"
				      	type="datetime"
				      	placeholder="请选择日期"
				      	value-format="yyyy-MM-dd HH:mm:ss"
				      	:picker-options="start_Date" style="width: 80%;">
				    </el-date-picker>
				</el-form-item>
		        <el-form-item label="截至日期" prop="validEndTime">
				    <el-date-picker
				      	v-model="ruleForm.validEndTime"
				      	type="datetime"
				      	placeholder="请选择日期"
				      	value-format="yyyy-MM-dd HH:mm:ss"
				      	:picker-options="end_Date" style="width: 80%;">
				    </el-date-picker>
				</el-form-item>
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
		    </span>
    	</el-dialog>

    	<!-- 兑换详情弹窗 -->
		<el-dialog title="兑换详情" :visible.sync="dialogVisible2" width="52%" :before-close="handleClose2">
			<div class="searchBtn" style="border:none;display:flex; margin-top:-20px">
				<span style="margin:10px 10px 0 0">兑换状态</span>
				<div class="topinput">
					<el-select v-model="detailId" placeholder="请选择兑换状态" style="width:100%">
					    <el-option
					      	v-for="item in options"
					      	:key="item.value"
					      	:label="item.label"
					      	:value="item.value">
					    </el-option>
				  	</el-select>
			  	</div>
				<el-date-picker
			      	v-model="timeVal2"
		      		type="daterange"
		      		range-separator=" 至 "
		      		start-placeholder="兑换开始日期"
		      		end-placeholder="兑换结束日期"
	      			value-format="yyyy-MM-dd" style="margin:0 10px">
			    </el-date-picker>
			    <el-button type="primary" @click="search_mine2">搜索</el-button>
		    </div>
		    <el-table  :data="exchangeCodeData" highlight-current-row  tooltip-effect="dark" style="width: 100%">
			    <el-table-column prop="exchangeCode" label="兑换码"></el-table-column>
			    <el-table-column prop="used" label="兑换状态">
			    	<template slot-scope="scope">
		    			{{scope.row.used==0?'未兑换':'已兑换'}}
		    		</template>
			    </el-table-column>
			    <el-table-column prop="status" label="作废状态">
			    	<template slot-scope="scope">
		    			{{scope.row.status==0?'未作废':'已作废'}}
		    		</template>
			    </el-table-column>
			    <el-table-column prop="userId" label="用户ID"></el-table-column>
				<el-table-column prop="nickname" label="用户昵称"></el-table-column>
				<el-table-column prop="exchangeDate" :formatter="this.global.dateFormat" label="兑换日期"></el-table-column>
			</el-table>
		  	<div style="margin-top: 20px">
				<el-button type="primary" size='small' style="cursor:pointer" @click="educe">导出</el-button>
				<el-button type="danger" style="float:right; margin-left:20px;cursor:pointer" size='small' @click="cancel">作废</el-button>
		    	<div style="float:right">
				    <el-pagination @current-change="handleCurrentChangePage2" :current-page="pageNum2" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage2"></el-pagination>
				</div>

				<div style="clear:both"></div>
			</div>
    	</el-dialog>
	</div>
</template>
<script>
export default {
  	mounted() {
  		this.init(); 	
  	},
  	data() {
    	return {
    		pageNum: 1,
		    limit: 10,
		    totalPage: 10,
		    pageNum2: 1,
		    totalPage2:10,
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tableData3: [],
	      	exchangeCodeData:[],
	      	dialogVisible: false,
	      	ruleForm: {
	      		typeId:'',
	      		salesName:'',
	      		salesTypeId:'',
	      		durationName:'',
	      		durationId:''
      		},
      		timeVal:'',
      		timeVal2:'',
      		dialogVisible2: false,
      		options: [
      			{value: '',label: '全部'}, 
      			{value: '0',label: '未兑换'}, 
      			{value: '1',label: '已兑换'},
      		],
      		vipTypeList:[
      			{id:1,type:'VIP'},
      			{id:2,type:'LIVE_VIP'},
      			{id:3,type:'AI_VIP'},
      			{id:4,type:'VIP+AI_VIP'}
      		],
      		rules:{
      			title: [
		            { required: true, message: '请输入兑换码名称', trigger: 'blur' },
		            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
		        ],
		        quantity: [
		            { required: true, message: '生成数量不能为空'},
      				{ type: 'number', message: '生成数量必须为数字值'}
		        ],
		        validStartTime: [
	            	{ type: 'string', required: true, message: '请选择生效日期', trigger: 'change' }
	          	],
	          	validEndTime: [
	            	{ type: 'string', required: true, message: '请选择截至日期', trigger: 'change' }
	          	],
	          	typeId:[
	          		{ required: true, message: '请选择兑换码类型', trigger: 'change' }
	          	],
	          	salesTypeId:[
	          		{ required: true, message: '请选择销售类型', trigger: 'change' }
	          	],
	          	vipType:[
	          		{ required: true, message: '请选择会员类型', trigger: 'change' }
	          	],
      		},
      		detailId:'',//兑换详情状态
        	start_Date: { //时间限制
		       	disabledDate: time => {
	                if(this.ruleForm.validEndTime) {
	                    return time.getTime() < Date.now()-8.64e7 || time.getTime() > this.ruleForm.validEndTime;
	                }   
	                return time.getTime() < Date.now()-8.64e7;
	            }
		    },
		    end_Date: {
	            disabledDate: time => {
	                return time.getTime() < Date.now()-8.64e7 || time.getTime() < this.ruleForm.validStartTime;
	            }
		  	},
		  	groupId:'',
		  	exchangeCodeTypeData:[],//兑换码类型
		  	salesTypeData:[],//销售类型
		  	durationData:[],//有效期
		  	typeIdShow:false,
		  	salesTypeIdShow:false
	    };
  	},
  	methods:{
  		init(){//视频列表
  			var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		createTimeFrom:this.timeVal?this.timeVal[0].valueOf():'',
        		createTimeTo:this.timeVal?this.timeVal[1].valueOf():'',
      		};
      		this.$get("/exchangeCode/group", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData3 = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		exchangeCodeType(){
  			this.$get("/exchangeCode/type")
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.exchangeCodeTypeData = res.data;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		typeId(val){
  			this.ruleForm.typeId=val;
  			if(val){
	      		this.salesType('change');
	      	}
  		},
  		salesTypeId(val){
  			this.ruleForm.salesTypeId=val;
  			if(val){
  				this.duration('change')
  			}
  		},
  		durationId(val){
  			this.ruleForm.durationId=val;
  		},
  		salesType(e){
  			this.$get("/exchangeCode/salesType/"+this.ruleForm.typeId)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.salesTypeData = res.data;
            		if(res.data.length){
	            		if(e=='change'){
	            			this.ruleForm.salesName=res.data[0].salesTypeCode+'-'+res.data[0].salesType;
	            			this.ruleForm.salesTypeId=res.data[0].id;
	            			this.duration('change');
	            			this.typeIdShow=true
	            		}else{
	            			this.typeIdShow=false;
	            		}
	            	}
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		duration(e){
  			this.$get("/exchangeCode/duration/"+this.ruleForm.salesTypeId)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.durationData = res.data;
            		if(res.data.length){
	            		if(e=='change'){
	            			this.ruleForm.durationName=res.data[0].durationType==1?res.data[0].duration+'天':res.data[0].duration+'个月';
	            			this.ruleForm.durationId=res.data[0].id;
	            			this.salesTypeIdShow=true
	            		}else{
	            			this.salesTypeIdShow=false;
	            		}
	            	}
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		search_mine(){
  			this.pageNum=1;
  			this.init()
  		},
  		search_mine2(){
	    	this.pageNum2=1;
	    	this.detail()
	    },
  		//当前页数
	    handleCurrentChangePage(val) {
	    	this.pageNum = val;
	      	this.init()
	    },
	    handleCurrentChangePage2(val){
	    	this.pageNum2 = val;
	      	this.detail()
	    },
  		add(row){
  			this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	      		this.ruleForm={
	      			menuSort:1
	      		}
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	this.currentRow='';
	      	this.dialogVisible = true;
	      	this.exchangeCodeType();
  		},
  		convertDetail(id){
  			if(id){
  				this.groupId=id;
  				this.detail()	
  			}
  		},
  		detail(){
  			var params = {
        		pageNum: this.pageNum2,
        		limit: this.limit,
        		groupId:this.groupId,
        		createTimeFrom:this.timeVal2?this.timeVal2[0].valueOf():'',
        		createTimeTo:this.timeVal2?this.timeVal2[1].valueOf():'',
        		used:this.detailId
      		};
      		this.$get("/exchangeCode/detail", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
          			this.dialogVisible2 = true;
            		this.exchangeCodeData = res.data.list;
            		this.totalPage2 = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	this.ruleForm={
			        
		      	}
	      	}
	      	done();
	    },
	    handleClose2(row) {
	    	this.detailId='';
	    	this.timeVal2='';
	    	this.pageNum2=1;
	    	this.$refs.multipleTable.setCurrentRow(row);
	      	this.dialogVisible2 = false;
	    },
	    //选择需要修改的权限
  		change(e){
  			this.$forceUpdate()
  		},
  		educe(){//导出
  			var date = new Date();
  			var date1=date.toLocaleDateString();
  			var params = {
        		pageNum: this.pageNum2,
        		limit: this.limit,
        		groupId:this.groupId,
        		createTimeFrom:this.timeVal2?this.timeVal2[0].valueOf():'',
        		createTimeTo:this.timeVal2?this.timeVal2[1].valueOf():'',
        		used:this.detailId
      		};
        	this.$axios({
	          	method: 'get',
	          	url: '/exchangeCode/detail/excel',
	          	params,
	          	responseType: 'blob'
        	})
	        .then((res) => { // 处理返回的文件流
	          	console.log(res)
	            const content = res
	            const blob = new Blob([content.data])
	            const fileName = date1+'兑换码列表.xls'
	            if ('download' in document.createElement('a')) { // 非IE下载
	              	const elink = document.createElement('a')
	              	elink.download = fileName
	              	elink.style.display = 'none'
	              	elink.href = URL.createObjectURL(blob)
	              	document.body.appendChild(elink)
	              	elink.click()
	              	URL.revokeObjectURL(elink.href) // 释放URL 对象
	              	document.body.removeChild(elink)
	            } else { // IE10+下载
	              	navigator.msSaveBlob(blob, fileName)
	            }
	        })
  		},
  		cancel(){
  			var that=this;
  			that.$confirm("确定要将未兑换的兑换码作废?此操作不可撤销", "提示", {
	            confirmButtonText: "确定",
	            cancelButtonText: "取消",
	            type: "warning"
          	})
          	.then(() => {
          		that.$axios.put("/exchangeCode/cancel/"+that.groupId)
	          	.then(res => {
	            	if (res.data.code == 0) {
	              		that.$message({
	                		message: "作废成功",
	                		type: "success"
	              		});
	              		that.pageNum2 = 1;
	              		that.detail();
	            	} else {
	              		that.$message({
	                		message: res.data.message,
	                		type: "warning"
	              		});
	              		return false;
	            	}
	          	})
          	})	
  		},
	    onSubmit(formName) {	    
	    	this.$refs[formName].validate((valid) => {
	          	if (valid) {	            	
	            	console.log(this.ruleForm)
	            	//return false
	            	this.$post("/exchangeCode", JSON.stringify(this.ruleForm))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: '添加成功',
	                    		type: "success"
	                  		});		                  		
	                  		this.$refs.ruleForm.resetFields();
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	} else {
	            	console.log('error submit!!');
	            	return false;
	          	}
	        });

    	},
  	}
}
</script>
<style scoped>
::deep
.el-date-editor .el-range-separator{
	padding: 0
}
.el-radio{
	margin: 0
}
.convert_input{
	margin: 0 10px
}
</style>


// WEBPACK FOOTER //
// src/views/conversionCodeList/index.vue